var map = {
	"./alt4.jpg": "096b",
	"./alt5.jpg": "9e18",
	"./alt6.jpg": "cba9",
	"./alt7.jpg": "8783",
	"./alt8.jpg": "f43a",
	"./alt9.jpg": "0d19",
	"./altheute.jpg": "5246",
	"./urkunde.jpg": "70be",
	"./wettbewerb.jpg": "f938"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a9dc";